module.exports = __webpack_public_path__ + "img/blog-05.25d61276.jpg";